module.exports = __webpack_public_path__ + "static/media/csv.3bc6566e.svg";